export const isFreePlan = (plan) => (
  String(plan?.name || "").toLowerCase() === "free" || Number(plan?.price) === 0
)

const billingInterval = (plan) => plan?.billing_interval || plan?.plan?.billing_interval

const maxDocuments = (plan) => Number(
  plan?.max_documents ?? plan?.max ?? plan?.plan?.max_documents ?? 0
)

export const isPlanChangeOptionAllowed = (currentPlan, targetPlan) => {
  if (!targetPlan) return false
  if (billingInterval(currentPlan) !== "Yearly") return true
  if (isFreePlan(targetPlan)) return true

  return (
    billingInterval(targetPlan) === "Yearly" &&
    maxDocuments(targetPlan) > maxDocuments(currentPlan)
  )
}
